/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Select } from '@blueprintjs/select';
import { Button, Classes, MenuItem } from '@blueprintjs/core';
import React from 'react';
import { PropTypes } from 'prop-types';
import { ColorAliases, Variables as VARIABLES } from 'styles/variables';

function getValue(item = {}) {
	return item.value;
}

function getLabel(item = {}) {
	return item.label;
}

export const LIMIT_TYPES = {
	NO_LIMIT: 'NO_LIMIT',
	AUTO: 'AUTO',
};

const ItemRenderer = (item, { handleClick, modifiers, index }) => {
	if (!modifiers.matchesPredicate) {
		return null;
	}
	return (
		<MenuItem
			key={index}
			active={modifiers.active}
			disabled={modifiers.disabled}
			// label={item}
			onClick={handleClick}
			text={getLabel(item)}
		/>
	);
};

const _options = [
	// ...insertIf(canRenderNoLimit, {
	// 	label: 'No Limit',
	// 	value: LIMIT_TYPES.NO_LIMIT,
	// }),
	// ...insertIf(canRenderAuto, {
	// 	label: 'Auto',
	// 	value: LIMIT_TYPES.AUTO,
	// }),
	{
		label: '1,000,000',
		value: 1000000,
	},
	{
		label: '100,000',
		value: 100000,
	},
	{
		label: '10,000',
		value: 10000,
	},
	{
		label: '5,000',
		value: 5000,
	},
	{
		label: '1,000',
		value: 1000,
	},
	{
		label: '100',
		value: 100,
	},
	{
		label: '50',
		value: 50,
	},
	{
		label: '20',
		value: 20,
	},
	{
		label: '10',
		value: 10,
	},
];
export const LimitDropdown = ({
	activeLimit,
	onLimitChanged,
	cardIndex,
	endpointQuery,
	options = _options,
	...rest
}) => {
	const activeItem = options.find((option) => option.value === activeLimit);
	if(activeItem === undefined && activeLimit !== LIMIT_TYPES.AUTO) //can be AUTO on init render, but then set a moment later
		console.error(`Limit Drop Down: Active Item not found in options for ${rest.label}. Check Widgets default config`);
	return (
		<Select
			items={options}
			// itemPredicate={filterItem}
			filterable={false}
			itemRenderer={ItemRenderer}
			onItemSelect={(option) => {
				onLimitChanged(cardIndex, endpointQuery, getValue(option));
			}}
			activeItem={activeItem}
			popoverProps={{ minimal: true }}
			{...rest}
		>
			<Button
				rightIcon="caret-down"
				className={`${Classes.MINIMAL}`}
				css={limitDropdownStyles}
				text={getLabel(activeItem)}
			/>
		</Select>
	);
};

LimitDropdown.propTypes = {
	activeLimit: PropTypes.any,
	canRenderAuto: PropTypes.any,
	canRenderNoLimit: PropTypes.any,
	label: PropTypes.string,
	onLimitChanged: PropTypes.any,
};

export function getLimitValue(limitTo, autoLimitVal, noLimitVal) {
	let limitToUse = limitTo;
	if (limitTo === LIMIT_TYPES.AUTO) {
		limitToUse = autoLimitVal;
	} else if (limitTo === LIMIT_TYPES.NO_LIMIT) {
		limitToUse = noLimitVal;
	}
	return limitToUse;
}

const limitDropdownStyles = css`
	border: 1px solid #CED9E0;
	border-radius: 3px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	& .bp3-button-text {
		font-family: ${VARIABLES.PT_FONT_FAMILY};
		font-size: ${VARIABLES.PT_FONT_SIZE};
		color: ${ColorAliases.PT_ICON_COLOR};
		line-height: 18px;
	}
`;

export function generateLimitDropdownOptionsFromList(listOfStrings) {
	return listOfStrings.map(label => ({label, value: parseInt(label.replace(/,/g, ''), 10)}))
}
